/**
 * Listen to changes to the Recipe notes textarea and save it
 */
export default class RecipeNotes {
	/**
	 * Invokes method to listen to the Textarea field
	 * 
	 * @return {undefined}
	 */
	constructor() {

		// Reference to the class instance
		const _this = this;

		// Reference to the textarea.
		const $textarea = document.getElementById( 'uap-notes-metabox__textarea' );

		let hasUnsavedData = false;
		
		// Adjust the height to fit content initially
		if ($textarea.value) {
			this.resizeTextarea($textarea);
		}

		// Add event listener to the textarea
		$textarea.addEventListener( 'input', event => {
			// Set the flag to indicate that there is unsaved data 
			hasUnsavedData = true;
			// Resize the textarea
			_this.resizeTextarea( $textarea );
		} );

		document.getElementById( 'uap-notes-metabox__textarea' ).addEventListener( 'blur', event => {
			// Save only if the value changed
			if ( hasUnsavedData ) {
				UncannyAutomator._core.recipe.setRecipeNotes( event.target.value )
					.then( ( response ) => {
						hasUnsavedData = false;
					} );
			}
		} );
	}

	/**
	 * Resize the textarea to fit the content
	 * 
	 * @param {HTMLElement} $textarea The textarea to resize
	 * @return {undefined}
	 */
	resizeTextarea( $textarea ) {
		$textarea.style.height = 'auto';
		$textarea.style.height = ( $textarea.scrollHeight ) + 'px';
	}
}
